import { createContext, ReactNode, useContext } from 'react';
import { ModalV3Id, ModalV3State } from './useModalV3';

export type OpenModalV3 = (id: ModalV3Id, props?: Record<string, unknown>) => void;

interface ModalV3ContextType {
  openModalV3: OpenModalV3;
  closeModalV3: () => void;
  modalV3State: ModalV3State;
}

const ModalV3Context = createContext<ModalV3ContextType | undefined>(undefined);

export const useModalV3Context = () => {
  const context = useContext(ModalV3Context);
  if (!context) {
    throw new Error('useModalV3Context must be used within a ModalV3ContextProvider');
  }
  return context;
};

interface ModalV3ContextProviderProps {
  children: ReactNode;
  openModalV3: OpenModalV3;
  closeModalV3: () => void;
  modalV3State: ModalV3State;
}

export const ModalV3ContextProvider = ({
  children,
  openModalV3,
  closeModalV3,
  modalV3State,
}: ModalV3ContextProviderProps) => (
  <ModalV3Context.Provider value={{ openModalV3, closeModalV3, modalV3State }}>
    {children}
  </ModalV3Context.Provider>
);
